import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaBlock } from '../CtaBlock';
import { afterItems, beforeItems } from '../../data/content';
export function TransformationSection() {
  return <section className="bg-white py-14 sm:py-20" aria-labelledby="transformation-title" data-id="element-312" data-mp="3hw99egkfvsa1">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-313" data-mp="3mxosi3323ops">
        <SectionHeading eyebrow="The transformation" title={<span id="transformation-title" data-id="element-315" data-mp="jh8bp9kp3esq">
              From clinical uncertainty to confidence in every consultation
            </span>} data-id="element-314" data-mp="ehc3ey4yt17d" />

        <div className="mt-10 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-316" data-mp="5j05eb1rr14w">
          <div className="overflow-hidden rounded-3xl border-2 border-alert-500/25 bg-alert-500/[0.04]" data-id="element-317" data-mp="9h7npabvsai7">
            <div className="bg-alert-600 px-4 py-3" data-id="element-318" data-mp="2q5l8n5mogoww">
              <h3 className="text-center text-sm font-black uppercase tracking-[0.18em] text-white sm:text-base" data-id="element-319" data-mp="2u8hynhejrnav">
                Before
              </h3>
            </div>
            <ul className="space-y-3 p-4 sm:p-5" data-id="element-320" data-mp="2h7hghuz1nmuw">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-321" data-mp="2c8elz4gowz16">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert-500/15" data-id="element-322" data-mp="2q6uo0i3ly1cz">
                    <XIcon className="h-3.5 w-3.5 text-alert-600" aria-hidden="true" data-id="element-323" data-mp="2m6kkdc3afn1a" />
                  </span>
                  <span className="text-[14px] font-medium leading-snug text-navy-800 sm:text-[15px]" data-id="element-324" data-mp="301wd5dxvv3fk">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="overflow-hidden rounded-3xl border-2 border-clinic-500/30 bg-clinic-50/60" data-id="element-325" data-mp="34v7q7wtaggfx">
            <div className="bg-clinic-600 px-4 py-3" data-id="element-326" data-mp="3iu7cixtbwj8x">
              <h3 className="text-center text-sm font-black uppercase tracking-[0.18em] text-white sm:text-base" data-id="element-327" data-mp="3iv09x86edwee">
                After
              </h3>
            </div>
            <ul className="space-y-3 p-4 sm:p-5" data-id="element-328" data-mp="2bjarqmf6q1pj">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-329" data-mp="2gidsvvs1nns8">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-clinic-500/20" data-id="element-330" data-mp="2kj63ascnjyq3">
                    <CheckIcon className="h-3.5 w-3.5 text-clinic-700" aria-hidden="true" data-id="element-331" data-mp="2pao67ly8k9dp" />
                  </span>
                  <span className="text-[14px] font-semibold leading-snug text-navy-900 sm:text-[15px]" data-id="element-332" data-mp="2u7xs4rmf22ws">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <CtaBlock kicker="Move to the green side in your next consultation — not next year." label="👉 I want to walk into every consultation prepared" data-id="element-333" data-mp="3452iz4r7imjx" />
      </div>
    </section>;
}